import classNames from 'classnames';
import React from 'react';
import Icon from '@/components/atoms/icon/icon';
import styles from './layout-picker.module.scss';

export type Layout = 'list' | 'map';

export interface LayoutPickerItem {
  icon: IconName;
  value: Layout;
}

export interface LayoutPickerProps {
  /** The active layout */
  activeLayout?: Layout;
  /** The class name to apply */
  className?: string;
  /** The items to render as toggle */
  items: LayoutPickerItem[];
  /** The function that returns the selected layout */
  onClick: (layout: Layout) => void;
}

const LayoutPicker = ({
  activeLayout = 'list',
  className,
  items = [],
  onClick,
}: LayoutPickerProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      {items.map((item, itemIndex) => (
        <button
          key={itemIndex}
          className={classNames(styles.layoutPickerItem, {
            [styles.isActive]: item.value === activeLayout,
          })}
          onClick={() => onClick(item.value)}
        >
          <Icon name={item.icon} size={24} />
        </button>
      ))}
    </div>
  );
};

LayoutPicker.displayName = 'LayoutPicker';

export default LayoutPicker;
